import React, { Component } from 'react';
import { List, Get, Create, Update } from './graphql.js';
import CompetitionsComponent from '../../components/Competitions';
import { toAwsJson, updateInPath } from '../../../../common/utils';
import { getList, getItem, setItem } from '../../../common/utils';
import { clone } from 'ramda';

export default class Competitions extends Component {
  constructor() {
    super();

    this.state = {
      data: [],
      loading: false,
      eventId: null
    };
    this.filter = {};
  }

  fetchData = async (filter) => {
    if (filter) {
      this.filter = clone(filter);
    }

    this.setState(s => updateInPath(s, 'loading', true));
    const data = await getList('listCompetitions', {
      query: List,
      variables: { filter: (filter || this.filter) }
    }, ['price', 'coupons']);
    this.setState(s => updateInPath(s, 'data', data));
    this.setState(s => updateInPath(s, 'loading', false));
  }

  handleCompetitionSave = async (data) => {
    const d = clone(data);

    // TODO this should happen in AWSMutation
    d.price = toAwsJson(d.price);
    d.coupons = toAwsJson(d.coupons);

    await setItem(
      d.competitionId ? Update : Create,
      d,
      [{ from: 'event', to: 'eventId' }]
    );

    this.fetchData();
  };

  handleCompetitionGet = async (eventId, competitionId, callback) => {
    return await getItem('getCompetition', {
      query: Get,
      variables: {
        competitionId: competitionId,
        eventId: eventId
      }
    }, ['price', 'coupons']);
  };

  render() {
    const { data, loading } = this.state;

    return (
      <CompetitionsComponent
        data={data}
        loading={loading}
        onCompetitionSave={this.handleCompetitionSave}
        onCompetitionView={this.handleCompetitionGet}
        refresh={this.fetchData}
      />
    );
  }
}



// WEBPACK FOOTER //
// ./src/private/admin/containers/Competitions/index.js